import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateProgram = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translatePrograms(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['programs']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateProgram;
